"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as a } from "react";
import { t as m } from "./Table.style-CZNieSq3.mjs";
const i = a(
  (s, r) => {
    const { className: t, ...o } = s;
    return /* @__PURE__ */ e.jsx(
      "tr",
      {
        ref: r,
        className: m({ class: t }),
        ...o
      }
    );
  }
);
export {
  i as TableRow
};
